module.exports = {"id":null,"jenis":null,"jenis_pungutan_id":null,"tarif_keringanan":null}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultFasilitas.json
// module id = NAut
// module chunks = 1